import AuthService from "../../services/api/auth.services";
import RegistrationService from "../../services/api/registration.services";
import AppServices from "@/services/api/app.services";
import AdminServices from "@/services/api/admin.services";
import PsychologistServices from "@/services/api/psychologist.services";
import RedactorServices from "../../services/api/redactor.services";
import PaymentServices from "../../services/api/payment.services";

const initialUserState = {
  authToken: null,
  name: "",
  lastName: "",
  patronymic: "",
  age: "",
  dateOfBirth: "",
  role: "",
  phoneCountryCode: "",
  phone: "",
  regPhone: "",
  unverifiedPhoneCountryCode: "",
  unverifiedPhone: "",
  email: "",
  verificationEmail: false,
  verificationCard: false,
  timeZone: "(UTC+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius",
  totalUserAnswers: "",
  patient: {},
  psychologistsList: {},
  psychologistProfile: [],
  userSettings: {
    notificationPerHour: false,
    notificationPerHours: null,
  },
  patientQuestionnaire: {
    questionnaire: {
      name: "",
      age: "",
      has_therapy_experience: "",
      consultation_type:"",
      timezone: "",
      profile_id: "",
      calendar_id: "",
      psychologistName: "",
      psychologistSurname: "",
      selectedSlot: {
        date: {
          translated: "",
        },
        slot: {
          time: "",
        },
      },
    },
    general_questions: {},
  },
  psychologistQuestionnaire: {
    photo: [],
    certificates: [],
    profile: {
      timezone: "(UTC+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius",
    },
    general_questions: {},
  },
  psychologist: {},
  filters: {},
};

let state = {
  testPhoto: "",
  isAuth: false,
  authToken: null,
  sessionId: null,
  sessionCookie: null,
  authCode: null,
  chosenPsychologistId: null,
  chosenCalendarId: null,
  psychologists: [],
  admin: {
    activeList: [],
    inactiveList: [],
    deactivatedList: [],
    archivedList: [],
    redactorList: {},
  },
  payment: {
    credential: {
      data: {},
    },
  },
  user: {
    admin: false,
    authToken: null,
    name: "",
    lastName: "",
    patronymic: "",
    age: "",
    dateOfBirth: "",
    role: "",
    locale: "uk",
    phoneCountryCode: "",
    phone: "",
    regPhone: "",
    email: "",
    verificationEmail: false,
    verificationCard: false,
    timeZone: "(UTC+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius",
    totalUserAnswers: "",
    patient: {},
    psychologistsList: {},
    userSettings: {
      notificationPerHour: false,
      notificationPerHours: null,
    },
    patientQuestionnaire: {
      questionnaire: {
        name: "",
        age: "",
        has_therapy_experience: "",
        consultation_type: "",
        timezone: "",
        profile_id: "",
        calendar_id: "",
        psychologistName: "",
        psychologistSurname: "",
        selectedSlot: {
          date: {
            translated: "",
          },
          slot: {
            time: "",
          },
        },
      },
      general_questions: {},
    },
    psychologistQuestionnaire: {
      photo: [],
      certificates: [],
      profile: {
        timezone: "(UTC+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius",
      },
      general_questions: {},
    },

    psychologist: {},
  },
  loginProvider: {
    provider: null,
    provider_id: null,
    token: null,
  },
  regLoginProvider: {
    provider: null,
    provider_id: null,
  },
  redirect: null,
  processLinkingLogin: false,
};

// the browser's zone (Europe/Kyiv): a fixed offset like +03:00 showed slots after the clocks change an hour off;
// the offset is only a fallback for browsers without Intl
function getClientOffset() {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (zone) return zone;
  } catch (e) {
    // no Intl: the offset below
  }
  const offset = new Date().getTimezoneOffset(); // хвилини
  const sign = offset <= 0 ? "+" : "-";
  const abs = Math.abs(offset);
  const hours = String(Math.floor(abs / 60)).padStart(2, '0');
  const minutes = String(abs % 60).padStart(2, '0');
  return `${sign}${hours}:${minutes}`;
}

const mutations = {
  SET_LOGIN_PROVIDER(state, payload) {
    state.loginProvider.provider = payload.provider;
    state.loginProvider.provider_id = payload.provider_id;
    state.loginProvider.token = payload.token;
  },
  SET_REG_LOGIN_PROVIDER(state, payload) {
    state.regLoginProvider.provider = payload.provider;
    state.regLoginProvider.provider_id = payload.provider_id;
  },
  SET_ADMIN_TRIGGER(state, payload) {
    state.user.admin = payload;
  },
  SET_REDIRECT(state, payload) {
    state.redirect = payload;
  },
  SET_PROCESS_LINKING_LOGIN(state, payload) {
    state.processLinkingLogin = payload;
  },
  CHANGE_LOCALE(state, payload) {
    state.user.locale = payload;
  },
  SET_PATIENT(state, payload) {
    state.user.patient = payload;
  },
  SET_TOTAL_USER_ANSWERS(state, payload) {
    state.user.totalUserAnswers = payload;
  },
  SWITCH_USER_ROLE(state, role) {
    state.user.role = role;
  },
  SET_LOCALE(state, locale) {
    state.user.locale = locale;
  },
  SET_USER_PHONE(state, payload) {
    state.user.phone = payload.phone;
    state.user.phoneCountryCode = payload.code;
  },
  SET_USER_UNVERIFIED_PHONE(state, payload) {
    state.user.unverifiedPhone = payload.phone;
    state.user.unverifiedPhoneCountryCode = payload.code;
  },
  SET_USER_REG_PHONE(state, payload) {
    state.user.regPhone = payload;
  },
  SET_USER_ROLE(state, payload) {
    state.user.role = payload;
  },
  SET_PSYCHOLOGISTS(state, payload) {
    state.psychologists = payload;
  },
  SET_USER(state, payload) {
    state.user = Object.assign({}, state.user, payload.data);
    /* state.user = { 
      ...state.user, 
      ...payload.data, 
    }; */
    state.isAuth = true;
    state.authToken = payload.access_token;
  },
  UPDATE_USER(state, payload) {
    state.user = payload.data;
  },
  SET_AUTH_TOKEN(state, payload) {
    state.isAuth = true;
    state.authToken = payload;
  },
  SET_LOGOUT(state) {
    state.isAuth = false;
    state.authToken = null;
    state.payment = { credential: { data: {} } };
    state.admin = {
      activeList: [],
      inactiveList: [],
      deactivatedList: [],
      archivedList: [],
      redactorList: {},
    };
    state.authCode = null;
    // state.user = JSON.parse(JSON.stringify(initialUserState));
    state.user = { ...initialUserState };
  },
  SET_USER_VERIFY(state) {
    state.user.is_verified = true;
  },
  SET_USER_EMAIL(state, payload) {
    state.user.email = payload;
  },
  SET_SESSION_COOKIE(state, payload) {
    state.sessionCookie = payload;
  },
  SET_AUTH_CODE(state, payload) {
    state.authCode = payload;
  },
  SET_PATIENT_GENERAL_QUESTIONS(state, payload) {
    state.user.patientQuestionnaire.general_questions = payload;
  },
  SET_PSYCHOLOGIST_QUESTIONNAIRE_PROFILE(state, payload) {
    state.user.psychologistQuestionnaire.profile = Object.assign(
      state.user.psychologistQuestionnaire.profile,
      payload
    );
  },
  SET_INITIAL_PSYCHOLOGIST_QUESTIONNAIRE(state) {
    state.user.psychologistQuestionnaire = initialUserState.psychologistQuestionnaire;
  },
  SET_PSYCHOLOGIST_QUESTIONNAIRE_GENERAL(state, payload) {
    state.user.psychologistQuestionnaire.general_questions = Object.assign(
      state.user.psychologistQuestionnaire.general_questions,
      payload
    );
  },
  SET_PATIENT_QUESTIONNAIRE_NAME(state, payload) {
    state.user.patientQuestionnaire.questionnaire.name = payload;
  },
  SET_PATIENT_QUESTIONNAIRE_AGE(state, payload) {
    state.user.patientQuestionnaire.questionnaire.age = payload;
  },
  SET_PATIENT_QUESTIONNAIRE_THERAPY_EXP(state, payload) {
    state.user.patientQuestionnaire.questionnaire.has_therapy_experience =
      payload;
  },
  SET_PATIENT_QUESTIONNAIRE_CONSULTATION_TYPE(state, payload) {
    state.user.patientQuestionnaire.questionnaire.consultation_type =
      payload;
  },
  SET_USER_TIMEZONE(state, payload) {
    state.user.timezone = payload;
  },
  SET_PATIENT_QUESTIONNAIRE_PROFILE_ID(state, payload) {
    state.user.patientQuestionnaire.questionnaire.profile_id = payload;
  },
  SET_PATIENT_QUESTIONNAIRE_PSYCHOLOGIST_NAME(state, payload) {
    state.user.patientQuestionnaire.questionnaire.psychologistName = payload;
  },
  SET_PATIENT_QUESTIONNAIRE_PSYCHOLOGIST_SURNAME(state, payload) {
    state.user.patientQuestionnaire.questionnaire.psychologistSurname = payload;
  },
  SET_PATIENT_QUESTIONNAIRE_PSYCHOLOGIST_PHOTO(state, payload) {
    state.user.patientQuestionnaire.questionnaire.psychologistPhoto = payload;
  },
  SET_PATIENT_QUESTIONNAIRE_PSYCHOLOGIST_PRICE(state, payload) {
    state.user.patientQuestionnaire.questionnaire.psychologistPrice = payload;
  },
  SET_PATIENT_QUESTIONNAIRE_CALENDAR_ID(state, payload) {
    state.user.patientQuestionnaire.questionnaire.calendar_id = payload;
  },
  SET_PATIENT_QUESTIONNAIRE_SELECTED_SLOT(state, payload) {
    state.user.patientQuestionnaire.questionnaire.selectedSlot = payload;
  },
  SET_PSYCHOLOGIST(state, payload) {
    state.user.psychologist = payload;
  },
  SET_PSYCHOLOGIST_PROFILE (state, payload) {
    state.psychologistProfile = payload
  },
  SET_PSYCHOLOGISTS_LIST(state, payload) {
    state.user.psychologistsList = payload;
  },
  SET_CARD(state, payload) {
    state.user.payment_method.card_holder = payload.payment_method.card_holder;
    state.user.payment_method.masked_method =
      payload.payment_method.masked_method;
  },
  SET_USER_PHOTO(state, payload) {
    state.user.psychologistQuestionnaire.photo = payload;
  },
  SET_USER_CERTIFICATES(state, payload) {
    state.user.psychologistQuestionnaire.certificates = payload;
  },
  SET_PSYCHOLOGISTS_CARDS(state, payload) {
    payload.forEach((response) => {
      for (let i of response.data.data) i.openQuestionaryForm = false;
      response.config.url === "api/admin/psychologists/active"
        ? (state.admin.activeList = response.data.data)
        : (state.admin.inactiveList = response.data.data);
    });
  },
  SET_ACTIVE_CARDS(state, payload) {
    state.admin.activeList = payload.data.data;
  },
  SET_INACTIVE_CARDS(state, payload) {
    state.admin.inactiveList = payload.data.data;
  },
  SET_ACTIVE_PSYCHOLOGISTS (state, payload) {
    state.admin.activeList = payload
  },
  SET_INACTIVE_PSYCHOLOGISTS (state, payload) {
      state.admin.inactiveList = payload
  },
  SET_DEACTIVATED_PSYCHOLOGISTS (state, payload) {
    state.admin.deactivatedList = payload
  },
  SET_ARCHIVED_PSYCHOLOGISTS (state, payload) {
    state.admin.archivedList = payload
  },
  SET_CHOSEN_PSYCHOLOGIST_ID(state, payload) {
    state.chosenPsychologistId = payload;
  },
  SET_CHOSEN_CALENDAR_ID(state, payload) {
    state.chosenCalendarId = payload;
  },
  SET_REDACTORS_LIST(state, payload) {
    state.admin.redactorList = payload;
  },
  SET_PAYMENT_CREDENTIALS(state, payload) {
    state.payment.credential = payload;
  },
  SET_PAYMENT_METHOD(state, payload) {
    state.user.payment_method = payload;
  },
  SET_FILTERS (state, payload) {
    state.filters = payload
  }
};

// the latest request of every admin list of psychologists (filters reload all four at once)
const adminListSeq = {
  getActivePsychologists: 0,
  getInactivePsychologists: 0,
  getArchivedPsychologists: 0,
  getDeactivatedPsychologists: 0,
};

const actions = {
  setPatientGeneralQuestions({ commit }, payload) {
    commit("SET_PATIENT_GENERAL_QUESTIONS", payload);
  },
  setPatientQuestionnaireName({ commit }, payload) {
    commit("SET_PATIENT_QUESTIONNAIRE_NAME", payload);
  },
  setPatientQuestionnaireAge({ commit }, payload) {
    commit("SET_PATIENT_QUESTIONNAIRE_AGE", payload);
  },
  setPatientQuestionnaireTherapyExp({ commit }, payload) {
    commit("SET_PATIENT_QUESTIONNAIRE_THERAPY_EXP", payload);
  },
  setPatientQuestionnaireConsultationType({ commit }, payload) {
    commit("SET_PATIENT_QUESTIONNAIRE_CONSULTATION_TYPE", payload);
  },
  setUserTimezone({ commit }, payload) {
    commit("SET_USER_TIMEZONE", payload);
  },
  setPatientQuestionnaireProfileId({ commit }, payload) {
    commit("SET_PATIENT_QUESTIONNAIRE_PROFILE_ID", payload);
  },
  setPatientQuestionnaireCalendarId({ commit }, payload) {
    commit("SET_PATIENT_QUESTIONNAIRE_CALENDAR_ID", payload);
  },
  setPatientQuestionnairePsychName({ commit }, payload) {
    commit("SET_PATIENT_QUESTIONNAIRE_PSYCHOLOGIST_NAME", payload);
  },
  setPatientQuestionnairePsychSurname({ commit }, payload) {
    commit("SET_PATIENT_QUESTIONNAIRE_PSYCHOLOGIST_SURNAME", payload);
  },
  setPatientQuestionnairePsychPhoto({ commit }, payload) {
    commit("SET_PATIENT_QUESTIONNAIRE_PSYCHOLOGIST_PHOTO", payload);
  },
  setPatientQuestionnairePsychPrice({ commit }, payload) {
    commit("SET_PATIENT_QUESTIONNAIRE_PSYCHOLOGIST_PRICE", payload);
  },
  setPatientQuestionnaireSelectedSlot({ commit }, payload) {
    commit("SET_PATIENT_QUESTIONNAIRE_SELECTED_SLOT", payload);
  },
  setQuestionnaireProfile({ commit }, payload) {
    commit("SET_PSYCHOLOGIST_QUESTIONNAIRE_PROFILE", payload);
  },
  setUserRegPhone({ commit }, payload) {
    commit("SET_USER_REG_PHONE", payload);
  },
  setRegLoginProvider({ commit }, payload) {
    commit("SET_REG_LOGIN_PROVIDER", payload);
  },
  setInitialQuestionnaire({ commit }) {
    commit("SET_INITIAL_PSYCHOLOGIST_QUESTIONNAIRE");
  },
  setQuestionnaireGeneral({ commit }, payload) {
    commit("SET_PSYCHOLOGIST_QUESTIONNAIRE_GENERAL", payload);
  },
  setEmail({ commit }, payload) {
    commit("SET_USER_EMAIL", payload);
  },
  setUserPhoto({ commit }, payload) {
    commit("SET_USER_PHOTO", payload);
  },
  setUserCertificates({ commit }, payload) {
    commit("SET_USER_CERTIFICATES", payload);
  },
  setChosenPsychologistId({ commit }, payload) {
    commit("SET_CHOSEN_PSYCHOLOGIST_ID", payload);
  },
  setChosenCalendarId({ commit }, payload) {
    commit("SET_CHOSEN_CALENDAR_ID", payload);
  },
  setLocale({ commit }, payload) {
    commit("SET_LOCALE", payload);
  },
  // eslint-disable-next-line no-empty-pattern
  loginSocial({ commit }, data) {
    return new Promise((resolve, reject) => {
      AuthService.post("loginSocial", data)
        .then((response) => {
          commit("SET_USER", response.data);
          commit("app/CHANGE_LOCALE", response.data.data.locale, {
            root: true,
          });
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  linkLogin({ commit }, data) {
    return new Promise((resolve, reject) => {
      AppServices.post("linkLogin", {}, data)
        .then((response) => {
          commit("SET_USER", response.data);
          commit("app/CHANGE_LOCALE", response.data.data.locale, {
            root: true,
          });
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  linkOauthLogin({ commit }, data) {
    return new Promise((resolve, reject) => {
      AppServices.post("linkOauthLogin", {}, data)
        .then((response) => {
          commit("SET_USER", response.data);
          commit("app/CHANGE_LOCALE", response.data.data.locale, {
            root: true,
          });
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  restoreAccount({ commit }) {
    return new Promise((resolve, reject) => {
      AuthService.post("restoreAccount")
        .then((response) => {
          commit("SET_USER", response.data);
          commit("app/CHANGE_LOCALE", response.data.data.locale, {
            root: true,
          });
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  deleteAccount() {
    return new Promise((resolve, reject) => {
      AppServices.delete("deleteAccount")
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  sendCode({}, data) {
    return new Promise((resolve, reject) => {
      AuthService.post("sendCode", data)
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  viberSendCode({}, data) {
    return new Promise((resolve, reject) => {
      AuthService.post(data.type, { phone: data.phone })
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  verifyCode({ commit }, data) {
    return new Promise((resolve, reject) => {
      AuthService.post("verifyCode", data, {
        // headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          commit("SET_USER", response.data);
          commit("app/CHANGE_LOCALE", response.data.data.locale, {
            root: true,
          });
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  sendUserRegCode({ commit }, data) {
    return new Promise((resolve, reject) => {
      RegistrationService.post("sendCode", data)
        .then((response) => {
          commit("SET_AUTH_CODE", response.data.auth_code);
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  verifyUserRegCode({}, data) {
    return new Promise((resolve, reject) => {
      RegistrationService.post("verifyCode", data)
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  sendPsychEmailCode({ commit }, data) {
    return new Promise((resolve, reject) => {
      RegistrationService.post("sendEmailCode", data)
        .then(() => {
          commit("SET_AUTH_CODE", "ready");
          return resolve("");
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  verifyEmailCode({}, data) {
    return new Promise((resolve, reject) => {
      RegistrationService.post("verifyEmailCode", data)
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  getPsychologists({ commit, state }, data) {
    let payload = Object.assign({}, data);

    if (!payload.timezone) {
      payload.timezone = (state.user && state.user.timezone) 
        ? state.user.timezone
        : getClientOffset();
    }
    return new Promise((resolve, reject) => {
      AppServices.post('getPsychologist', {}, payload)
        .then((response) => {
          commit('SET_PSYCHOLOGISTS', response.data.data)
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  getPsychologistProfile ({ commit, state }, data) {
    let payload = Object.assign({}, data);

    if (!payload.timezone) {
      payload.timezone = (state.user && state.user.timezone) 
        ? state.user.timezone
        : getClientOffset();
    }

    return new Promise((resolve, reject) => {
      AppServices.get('getPsychologistProfile', payload)
        .then((response) => {
          commit('SET_PSYCHOLOGIST_PROFILE', response.data.data)
          return resolve(response)
        }).catch((error) => reject(error))
    })
  },
  getProfile({ commit, state }, data) {
    let payload = Object.assign({}, data);

    if (!payload.timezone) {
      payload.timezone = (state.user && state.user.timezone) 
        ? state.user.timezone
        : getClientOffset();
    }

    return new Promise((resolve, reject) => {
      AppServices.get("getProfile", payload)
        .then((response) => {
          commit("UPDATE_USER", response.data);

          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-unused-vars
  updateProfile({ commit }, data) {
    return new Promise((resolve, reject) => {
      AppServices.post("getProfile", {}, data)
        .then((response) => {
          if (response) {
            commit("UPDATE_USER", response.data);
          }

          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  updatePsychologistPhoto({ state }, data) {
    return new Promise((resolve, reject) => {
      AdminServices.post("updatePsychologistPhoto", data.get("userId"), data)
        .then((response) => {
          if (response) {
            [...state.admin.inactiveList, ...state.admin.deactivatedList, ...state.admin.archivedList].forEach((psychologist) => {
              if (psychologist.id === response.data.data.id) {
                psychologist.photo = response.data.data.photo;
              }
            });
          }

          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  psychologistRegistration({ commit }, data) {
    return new Promise((resolve, reject) => {
      RegistrationService.post("psychologistRegistration", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          commit("SET_USER", response.data);
          commit("app/CHANGE_LOCALE", response.data.data.locale, {
            root: true,
          });
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  psychologistEditProfile({}, { id, payload }) {
    return new Promise((resolve, reject) => {
      AdminServices.post("editPsychologist", id, payload)
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  patientRegistration({ commit }, data) {
    return new Promise((resolve, reject) => {
      RegistrationService.post("patientRegistration", data, {})
        .then((response) => {
          commit("SET_USER", response.data);
          commit("app/CHANGE_LOCALE", response.data.data.locale, {
            root: true,
          });
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  requestListPsychologists({ commit, state }, data) {
    let payload = Object.assign({}, data);

    if (!payload.timezone) {
      payload.timezone = (state.user && state.user.timezone) 
        ? state.user.timezone 
        : getClientOffset();
    }

    return new Promise((resolve, reject) => {
      RegistrationService.post(
        "requestListPsychologists",
        data,
        {},
        payload
      )
        .then((response) => {
          commit("SET_PSYCHOLOGISTS_LIST", response.data);
          commit("SET_TOTAL_USER_ANSWERS", response.total_user_answers);
          return resolve("");
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  createCard({}, data) {
    return new Promise((resolve, reject) => {
      AppServices.post("createCard", {}, data)
        .then(() => {
          return resolve("");
        })
        .catch((error) => reject(error));
    });
  },

  deleteCard({ commit }, data) {
    return new Promise((resolve, reject) => {
      AppServices.delete("deleteCard", data)
        .then((response) => {
          commit("UPDATE_USER", response.data);
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  requestPsychologistCards({ commit }, arrRequests) {
    let requestActiveList = AdminServices.get("activePsychologists");
    let requestInactiveList = AdminServices.get("inactivePsychologists");
    return Promise.all(
      arrRequests ? arrRequests : [requestActiveList, requestInactiveList]
    )
      .then((response) => {
        commit("SET_PSYCHOLOGISTS_CARDS", response);
        return response;
      })
      .catch((error) => error);
  },
  // eslint-disable-next-line no-empty-pattern
  activatePsychologist({ /* dispatch, commit */ }, id) {
    return new Promise((resolve, reject) => {
      AdminServices.patch("activatePsychologist", id)
        .then((response) => {
          /* commit("SET_INACTIVE_CARDS", response);
          dispatch("requestPsychologistCards", [
            AdminServices.get("activePsychologists"),
          ]); */
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  deactivatePsychologist({ /* dispatch, commit */ }, id) {
    return new Promise((resolve, reject) => {
      AdminServices.patch("deactivatePsychologist", id)
        .then((response) => {
          /* commit("SET_ACTIVE_CARDS", response);
          dispatch("requestPsychologistCards", [
            AdminServices.get("inactivePsychologists"),
          ]); */
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  deletePsychologist({}, id) {
    return new Promise((resolve, reject) => {
      AdminServices.delete("deletePsychologist", id)
        .then((response) => {
          return resolve(response);
        })
        .catch(reject);
    });
  },
  getActivePsychologists ({ commit }, data) {
    const seq = ++adminListSeq.getActivePsychologists
    return AdminServices.get('activePsychologists', data).then((response) => {
      // an answer to an older filter/page (the admin already changed it) must not replace the newer list
      if (seq !== adminListSeq.getActivePsychologists) return { ...response, stale: true }
      commit('SET_ACTIVE_PSYCHOLOGISTS', response.data.data)
      return response
    })
  },
  getInactivePsychologists ({ commit }, data) {
    const seq = ++adminListSeq.getInactivePsychologists
    return AdminServices.get('newPsychologists', data).then((response) => {
      // an answer to an older filter/page (the admin already changed it) must not replace the newer list
      if (seq !== adminListSeq.getInactivePsychologists) return { ...response, stale: true }
      commit('SET_INACTIVE_PSYCHOLOGISTS', response.data.data)
      return response
    })
  },
  getArchivedPsychologists ({ commit }, data) {
    const seq = ++adminListSeq.getArchivedPsychologists
    return AdminServices.get('archivedPsychologists', data).then((response) => {
      // an answer to an older filter/page (the admin already changed it) must not replace the newer list
      if (seq !== adminListSeq.getArchivedPsychologists) return { ...response, stale: true }
      commit('SET_ARCHIVED_PSYCHOLOGISTS', response.data.data)
      return response
    })
  },
  // the admin archive: psychologists who will not work with the Platform, kept without deleting
  // eslint-disable-next-line no-empty-pattern
  archivePsychologist ({}, { id, archived }) {
    return AdminServices.patch(archived ? 'archivePsychologist' : 'unarchivePsychologist', id)
  },
  getDeactivatedPsychologists ({ commit }, data) {
    const seq = ++adminListSeq.getDeactivatedPsychologists
    return AdminServices.get('deactivatedPsychologists', data).then((response) => {
      // an answer to an older filter/page (the admin already changed it) must not replace the newer list
      if (seq !== adminListSeq.getDeactivatedPsychologists) return { ...response, stale: true }
      commit('SET_DEACTIVATED_PSYCHOLOGISTS', response.data.data)
      return response
    })
  },
  downloadPsychologistInfo() {
    return new Promise((resolve, reject) => {
      AdminServices.get("downloadPsychologistsInfo")
        .then((response) => {
          const a = document.createElement("a");
          a.href =
            "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
            response.data.data.encoded;
          a.download = response.data.data.filename;
          a.click();
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  bookTimeSlotByPatient({}, data) {
    return new Promise((resolve, reject) => {
      AppServices.post("bookTimeSlotByPatient", {}, data)
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  cancelConsultationByPatient({}, data) {
    return new Promise((resolve, reject) => {
      AppServices.patch("cancelConsultationByPatient", data)
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  allowTimeSlotByPsyh({}, data) {
    return new Promise((resolve, reject) => {
      PsychologistServices.post("allowTimeSlot", {}, data)
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  changeLocale({ commit, state }, data) {
    commit("CHANGE_LOCALE", data);
    if (state.isAuth) {
      return new Promise((resolve, reject) => {
        let payload = { locale: data };
        AppServices.post("switchLocale", {}, payload, {})
          .then((response) => {
            location.reload();
            return resolve(response);
          })
          .catch(({ errors }) => reject(errors));
      });
    }
  },
  getRedactorsList({ commit }) {
    return new Promise((resolve, reject) => {
      RedactorServices.get("getRedactorsList", {})
        .then((response) => {
          commit("SET_REDACTORS_LIST", response.data.data);
          return resolve(response);
        })
        .catch(({ errors }) => reject(errors));
    });
  },
  createNewRedactor({ commit }, data) {
    return new Promise((resolve, reject) => {
      RedactorServices.post("createRedactor", {}, data)
        .then((response) => {
          commit("SET_REDACTORS_LIST", response.data.data);
          return resolve(response);
        })
        .catch(({ errors }) => reject(errors));
    });
  },
  deleteRedactor({ commit }, params) {
    return new Promise((resolve, reject) => {
      RedactorServices.delete("deleteRedactor", params)
        .then((response) => {
          commit("SET_REDACTORS_LIST", response.data.data);
          return resolve(response);
        })
        .catch(({ errors }) => reject(errors));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  cancelConsultationByPsyh({}, data) {
    return new Promise((resolve, reject) => {
      PsychologistServices.patch("cancelConsultation", data)
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  getPaymentCredentials({ commit }, data) {
    return new Promise((resolve, reject) => {
      PaymentServices.get("getCredentials", {}, data)
        .then((response) => {
          commit("SET_PAYMENT_CREDENTIALS", response.data);
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },

  sendPaymentCredentials({ commit }, data) {
    return new Promise((resolve, reject) => {
      PaymentServices.post("sendCredentials", {}, data)
        .then((response) => {
          commit("UPDATE_USER", response.data);
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  // eslint-disable-next-line no-empty-pattern
  sendRatingAfterSession({}, data) {
    return new Promise((resolve, reject) => {
      AppServices.post("sendRating", { id: data.id }, { rating: data.rating })
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  getPsychologistFilter ({ commit }) {
    return new Promise((resolve, reject) => {
      AppServices.get('getPsychologistFilter', {})
        .then((response) => {
          commit('SET_FILTERS', response.data.data)
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },
};

const getters = {
  getProcessLinkingLogin: (state) => state.processLinkingLogin,
  getRedirect: (state) => state.redirect,
  getLoginProvider: (state) => state.loginProvider,
  getRegLoginProvider: (state) => state.regLoginProvider,
  getPsychologists: (state) => state.psychologists,
  getPsychologistProfile: state => state.psychologistProfile,
  getUser: (state) => state.user,
  getAdminTrigger: (state) => state.user.admin,
  getAuthToken: (state) => state.authToken,
  getAuthParam: (state) => {
    return {
      isAuth: state.isAuth,
      authToken: state.authToken,
      userRole: state.user.role,
    };
  },

  getPatientGeneralQuestions: (state) =>
    state.user.patientQuestionnaire.general_questions,
  getUserPhone: (state) => state.user.phone,
  getUserPhoneCountryCode: (state) => state.user.phoneCountryCode,
  getUserUnverifiedPhone: (state) => state.user.unverifiedPhone,
  getUserUnverifiedPhoneCountryCode: (state) => state.user.unverifiedPhoneCountryCode,
  getUserRegPhone: (state) => state.user.regPhone,
  getUserEmail: (state) => state.user.email,
  getUserPhoto: (state) => state.user.psychologistQuestionnaire.photo,
  getCertificates: (state) => state.user.psychologistQuestionnaire.certificates,
  getUserQuestionnaireGeneralQuestions: (state) =>
    state.user.psychologistQuestionnaire.general_questions,
  getUserQuestionnaireProfile: (state) =>
    state.user.psychologistQuestionnaire.profile,
  isAuth: (state) => state.isAuth,
  getActivePsychologists: state => state.admin.activeList,
  getInactivePsychologists: state => state.admin.inactiveList,
  getDeactivatedPsychologists: state => state.admin.deactivatedList,
  getArchivedPsychologists: state => state.admin.archivedList,
  getChosenPsychologistId: (state) => state.chosenPsychologistId,
  getChosenCalendarId: (state) => state.chosenCalendarId,
  getPsychologistsList: (state) => state.user.psychologistsList,
  getPatientQuestionnaire: (state) => state.user.patientQuestionnaire,
  getPayCredentials: (state) => state.payment.credential,
  getRedactorsList: (state) => state.admin.redactorList,
  getSelectedLocale: (state) => state.user.locale,
  getAttachedPsychologist: (state) => state.user.attached_psychologist,
  // getPsychologistQuestionnaire: (state) => state.patient.psychologistQuestionnaire,
  getFiltersList: (state) => state.filters,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
